import ChangePasswordForm from "../../../components/forms/change_password/ChangePasswordForm"
import Modal from "../../../components/modal/Modal"
import { toggleChangePasswordModal } from "../../../redux/slices/globalSlice"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

export const ChangePasswordImport = {
    ChangePasswordForm,
    Modal,
    toggleChangePasswordModal,
    useDispatch,
    useSelector,
    useTranslation
}